export default __webpack_public_path__ + "static/media/3.401c149e.jpg";